import { IApplicationState } from '../../types/redux';
import { selectResults } from '../results';
import { getKey } from '../../utils/selected';

export const selectSelectedProducts = (state: IApplicationState) => {
  const { favoriteEntities } = selectResults(state);

  return favoriteEntities.filter(favoriteEntity => {
    const { entityId, entityType } = favoriteEntity;

    return Boolean(state.selected[getKey(entityId, entityType)]);
  });
};
